// Template: Campaign owner rejected the affiliate proposal notification
export const AffiliateProposalReject = `
<div>

  <div style="display: flex; align-items: center; gap: 12px; background: linear-gradient(135deg, #fff5f5, #ffe4e4); border: 1px solid #feb2b2; border-left: 3px solid #e53e3e; border-radius: 8px; padding: 12px 16px; margin-bottom: 20px;">
    <span style="font-size: 1.4rem; flex-shrink: 0;">❌</span>
    <div>
      <div style="font-size: 0.95rem; font-weight: 700; color: #742a2a;">Proposta recusada</div>
      <div style="font-size: 0.82rem; color: #c53030; margin-top: 2px;">O dono da campanha optou por não aceitar sua solicitação desta vez.</div>
    </div>
  </div>

  <p style="font-size: 0.95rem; color: #4a5568; line-height: 1.9; margin-bottom: 20px;">
    O usuário
    <a href="{{ownerProfileUrl}}" style="font-weight: 700; text-decoration: none; color: #6c63ff;">{{ownerName}}</a>
    <a href="{{ownerProfileUrl}}" style="background: linear-gradient(135deg, #6c63ff, #a855f7); color: #fff; font-weight: 600; font-size: 0.75rem; border-radius: 6px; padding: 3px 8px;">@{{ownerAtSign}}</a>
    recusou sua solicitação de afiliação à campanha
    <a href="{{campaignPageUrl}}" style="font-weight: 700; text-decoration: none; color: #6c63ff;">{{campaignName}}</a>
    <a href="{{campaignPageUrl}}" style="background: #f0f4ff; color: #6c63ff; border: 1px solid #c7d2fe; font-weight: 600; font-size: 0.75rem; border-radius: 6px; padding: 3px 8px;">#{{campaignKey}}</a>
    com <strong style="color: #1a202c;">{{commissionPercent}}%</strong> de comissão.
  </p>

  <div style="display: flex; gap: 12px; margin-bottom: 12px;">
    <div style="flex: 1; background: #f8faff; border: 1px solid #e0e7ff; border-radius: 10px; padding: 12px 16px;">
      <div style="font-size: 0.68rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.08em; color: #a0aec0; margin-bottom: 4px;">Comissão solicitada</div>
      <div style="font-size: 1.5rem; font-weight: 800; color: #6c63ff;">{{commissionPercent}}<span style="font-size: 0.9rem;">%</span></div>
    </div>
    <div style="flex: 1; background: #f8faff; border: 1px solid #e0e7ff; border-radius: 10px; padding: 12px 16px;">
      <div style="font-size: 0.68rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.08em; color: #a0aec0; margin-bottom: 4px;">Data da recusa</div>
      <div style="font-size: 0.95rem; font-weight: 700; color: #2d3748;">{{createdAt}}</div>
    </div>
  </div>

  <div style="display: flex; gap: 8px; background: #fffbeb; border: 1px solid #fde68a; border-left: 3px solid #f6ad55; border-radius: 8px; padding: 12px 16px; margin-bottom: 20px;">
    <span>💡</span>
    <span style="font-size: 0.85rem; color: #92400e; line-height: 1.65;">
      Você pode tentar se afiliar a outras campanhas ou enviar uma nova solicitação com um percentual diferente clicando em <strong>Administrar Propostas</strong> abaixo.
    </span>
  </div>

  <a href="{{campaignAffiliatePageUrl}}" style="display: block; width: 100%; background: #f8faff; color: #6c63ff; border: 1px solid #c7d2fe; border-radius: 8px; font-weight: 600; font-size: 0.88rem; padding: 10px 0; cursor: pointer; text-align: center; text-decoration: none;">
    Informações de Afiliação
  </a>

</div>
`;
